import { Assets, Texture } from 'pixi.js';
import { getTexturePreloadData } from '../getAssetsToPreload';

function keepCheckingForSprite(sprite: { texture: Texture; destroyed: boolean }, textureName: string): void {
  const initTexture = sprite.texture;

  const intervalId = setInterval((): void => {
    if (sprite.destroyed) {
      clearInterval(intervalId);
    } else if (Assets.cache.has(textureName)) {
      if (sprite.texture === initTexture) {
        sprite.texture = Texture.from(textureName);
      }
      clearInterval(intervalId);
    }
  }, 100);
}

export async function setTextureWithLoadingFallback(
  sprite: { texture: Texture; destroyed: boolean },
  textureName: string,
  url?: string,
): Promise<void> {
  if (textureName === '') {
    sprite.texture = Texture.EMPTY;
  }

  if (Assets.cache.has(textureName)) {
    sprite.texture = Texture.from(textureName);
    return;
  }

  const preloadData = getTexturePreloadData(textureName) ?? { width: 128, height: 128, assetToLoad: null };

  sprite.texture = Texture.EMPTY;
  const texture = Texture.EMPTY;

  if (preloadData.assetToLoad) {
    await Assets.load(preloadData.assetToLoad);
    if (sprite.destroyed || sprite.texture !== texture) return;
    sprite.texture = Texture.from(textureName);
  } else if (url) {
    await Assets.load(url);
    if (sprite.destroyed || sprite.texture !== texture) return;
    Assets.cache.set(textureName, Assets.get(url));
    sprite.texture = Texture.from(textureName);
  } else if (textureName !== '') {
    // might be external bundle, not loaded
    keepCheckingForSprite(sprite, textureName);
  }
}
